import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M17.385 21H6.615c-.85 0-1.538-.672-1.538-1.5V6h13.846v13.5c0 .828-.689 1.5-1.538 1.5zm-7.693-4.5v-6m4.616 6v-6M2 6h20m-7.692-3H9.692c-.85 0-1.538.672-1.538 1.5V6h7.692V4.5c0-.828-.689-1.5-1.538-1.5z" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
